var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 6v20a2 2 0 01-2 2h-5a2 2 0 01-2-2V6a2 2 0 012-2h5a2 2 0 012 2zM12 4H7a2 2 0 00-2 2v20a2 2 0 002 2h5a2 2 0 002-2V6a2 2 0 00-2-2z"
  })));
}
export default SvgPauseFill;